import React from 'react';
import classNames from 'classnames';
import { StyledChipTabs } from './index.style';

// `options`: [{ value, icon: Component }]. Chọn một tại một thời điểm.
const ChipTabs = ({ width, options, value, onChange }) => (
  <StyledChipTabs $width={width}>
    {options.map(({ value: optionValue, icon: Icon }) => (
      <button
        key={optionValue}
        type="button"
        aria-pressed={value === optionValue}
        className={classNames('chip-tab', {
          'chip-tab-active': value === optionValue,
        })}
        onClick={() => onChange(optionValue)}
      >
        <Icon />
      </button>
    ))}
  </StyledChipTabs>
);

export default ChipTabs;
